import React from "react";

import { ContentDivider } from "./styles";

export const Divider = ({ small = false }: { small?: boolean }): JSX.Element => {
  return <ContentDivider small={small} />;
};
